import type { FeatureSetting } from '@/features/feature-management/types/featureSetting';

export const MIN_RANGE = 0;
export const MAX_RANGE = 20_000;
export const INITIAL_RANGE = (MIN_RANGE + MAX_RANGE) / 2;

export const DEFAULT_GEO_AREA_SELECTION_FEATURE_VALUES: GeoAreaSelectionFeature['featureValues'] =
  {
    maxRadiusMeter: MAX_RANGE,
    defaultRadiusMeter: INITIAL_RANGE
  };

export type GeoAreaSelectionFeature = Omit<FeatureSetting, 'featureValues'> & {
  featureValues: {
    maxRadiusMeter: number;
    defaultRadiusMeter: number;
  };
};
